/// <amd-module name="Environments/ProviderCreateDetails/VirtualMachineGroups/Actions/VirtualMachineGroupCreateActions" />
import { ActionsHubBase, Action } from "Environments/Flux/ActionCreatorBase";
import { EnvironmentResourceReference } from "DistributedTask/Client/Contracts/TaskAgent";

export class VirtualMachineGroupCreateActions extends ActionsHubBase {

    public static getKey(): string {
        return "virtualmachinegroup-create-actions";
    }

    public initialize(instanceId?: string) {
        this._addResource = new Action<EnvironmentResourceReference>();
    }

    public get addVirtualMachinesResource(): Action<EnvironmentResourceReference> {
        return this._addResource;
    }
    
    private _addResource: Action<EnvironmentResourceReference>;
}
